import API from '../utils/axiosApiHR';
// import { printFrame } from '../helpers/common';
import FileSaver from 'file-saver';

/**Transfer */
export const fetchAssetTransfers = async (params) => {
  try {
    const { data } = await API.get('/assets/transfers', { params });
    return data;
  } catch (error) {
    throw error;
  }
};
export const saveAssetTransfer = async (body) => {
    try {
      if(body && body.CODE) {
        const { data } = await API.put(`/assets/transfer/${body.CODE}`, body);
        return data;
      } else {
        const { data } = await API.post('/assets/transfer', body);
        return data;
      }
    } catch (error) {
      throw error;
    }
};
export const getAssetTransfer = async ({Code}) => {
  try {
    const { data } = await API.get(`/assets/transfer/${Code}`);
    return data;
  } catch (error) {
    throw error;
  }
};
export const deleteAssetTransfer = async ({Code}) => {
  try {
    const { data } = await API.delete(`/assets/transfer/${Code}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const confirmAssetTransfer = async (body) => {
  try {
    const { data } = await API.post(`/assets/transfer/confirm`, body);
    return data;
  } catch (error) {
    throw error;
  }
};

export const printAssetTransfer = async ({Code}) => {
  try {
    const response = await API.get(`/assets/transfer/print/${Code}`, {
      responseType: 'blob'
    });
    const { data } = response;
    const namefile = response.headers['pcs-filename-suggestion'];
    let blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
    FileSaver.saveAs(blob, namefile);
    return true;
  } catch (error) {
    throw error;
  }
};
